import { action } from 'typesafe-actions';

import { UserLoyalty } from 'reducers/userLoyalty';

export const USER_LOYALTIES = 'USER_LOYALTIES';

export const setUsersLoyalties = (data: UserLoyalty[]) => action(USER_LOYALTIES, data);
